// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"5e5eb638","453":"fc209935","795":"114746e9"}[chunkId] + ".chunk.js";
};